module.exports = __webpack_public_path__ + "assets/img/23_27_big.ef381cd6.jpg";